const helperFunctions = {
  changePhoneNoFormat: function (param_phone_no) {
    if (param_phone_no) {
      let phoneno = "";
      if (!param_phone_no) {
        phoneno = "";
      } else if (param_phone_no.length == 10) {
        var cleaned = ("" + param_phone_no).replace(/\D/g, "");
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          var intlCode = match[1] ? "+1 " : "";
          phoneno = [intlCode, "", match[2], "-", match[3], "-", match[4]].join(
            ""
          );
        }
      } else if (param_phone_no.length > 10) {
        let str1 = param_phone_no.slice(0, 3);
        let str2 = param_phone_no.slice(3, 6);
        let conStr =
          str1 +
          "-" +
          str2 +
          "-" +
          param_phone_no.slice(6, Number(param_phone_no.length));
        phoneno = conStr;
      } else if (param_phone_no.length < 6) {
        phoneno = param_phone_no;
      } else if (param_phone_no.length > 6 && param_phone_no.length < 10) {
        let str1 = param_phone_no.slice(0, 3);
        let str2 = param_phone_no.slice(3, 6);
        let conStr =
          str1 +
          "-" +
          str2 +
          "-" +
          param_phone_no.slice(6, Number(param_phone_no.length));
        phoneno = conStr;
      }
      if (param_phone_no.includes("-")) {
        return param_phone_no;
      } else {
        return phoneno;
      }
    } else {
      return "";
    }
  },
  get_first_letter_capital: function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
};
export default helperFunctions;
